
<template>
  <div class="popup popup-text-only" style="overflow-x: hidden;">
    <header class="bar bar-nav">
      <div class="button button-link button-nav pull-right close-popup">
        <span class="icon icon-down close-popup">取消</span>
      </div>
      <h1 class='title'>
        <div>备注填写</div>
      </h1>
    </header>
   <div style="margin-top: 2.5rem;font-size: .7rem">
     填写说明:
     <div style="color: red">{{custRemark}}</div>
   </div>
    <div style="font-size: .7rem;margin-top: 20px">
      {{custRemark1}}
    </div>
    <div style="border: 1px solid">
      <textarea  v-model="data" placeholder='必填' style="    width: 100%"></textarea>
    </div>
    <div style="margin-left: 1rem;margin-top:15px;text-align: center;color: white"  ><button @click="checkData" style="background-color: #0a8ddf " :class="{'close-popup': popupTrue}">确定</button></div>
  </div>
</template>
<script>
//  import $ from 'jquery'
//  import emkt from '../../emkt'
  import {mapState, mapMutations} from 'vuex'
  export default {
    mounted () {
//      this.fetchdata()
    },
    created () {
//      this.fetchdata()
    },
    data () {
      return {
        radioChecked: '', // default
        popupTrue: true,
        data: ''
      }
    },
    watch: {
    },
    methods: {
      ...mapMutations([
        'POPUP_TEXT_RESULT', 'UPDATE_CUST_REMARK', 'UPDATE_CUST_REMARK1'
      ]),
      fetchdata () {
        console.log(this.custRemark)
      },
      checkData () {
        var _this = this
        let router = _this.$router.history.current.path
        let gData = _this.data
        let geneInfo = {}
        let gene = {}
        gene = {'data': gData}
        geneInfo[router] = gene
        _this.POPUP_TEXT_RESULT(geneInfo)
        _this.popupTrue = true
        console.log(geneInfo)
      }
    },
    computed: {
      ...mapState([
        'remarkData', 'custRemark', 'custRemark1'
      ])
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  input[type="radio"] {
    display: none;
  }
  .search_history {
    background-color: #fff;
    margin-bottom: 0.4rem;
  }

  .list-block {
    margin-top: 1rem;
  }

  .searchTr .searchBox.default {
    display: inline-block;
    text-decoration: none;
    color: #000000;
    font-size: .7rem;
    line-height: 1;
    background-color: #dddddd;
    padding: 0.5em;
    border-radius:0.2rem;
    text-align: center;
    margin-left: 2%;
    margin-top: 0.2rem;
  }
  .searchTr .searchBox.selected {
    display: inline-block;
    text-decoration: none;
    color: #dddddd;
    font-size: .7rem;
    line-height: 1;
    background-color: #0261b5;
    padding: 0.5em;
    border-radius:0.2rem;
    text-align: center;
    margin-left: 2%;
  }
  .searchRadioBox {
    display: inline-block;
  }

  .searchSecondTr .searchSecondBox .default {
    width: 20%;
    text-decoration: none;
    color: #000000;
    background-color: #ececec;
    padding: 0.5em;
    border-radius:30px;
    text-align: center;
    margin-left: 10%;
  }
  .searchSecondTr .searchSecondBox .selected {
    display: inline-block;
    width: 20%;
    text-decoration: none;
    color: #000000;
    background-color: #045aa5;
    padding: 0.5em;
    border-radius:30px;
    text-align: center;
    margin-left: 10%;
  }
  .borderBottom {
    border-bottom: 1px solid #dddddd;
  }
  .blueTitle {
    width: 4rem;
    border-bottom: 2px solid #0074D9;
  }
  .badge {
    color:#0894ec;
    background: white;
    text-decoration: none;
    font-size: 0.6rem;
  }
  .list-block .item-title {
    font-weight: bold;
  }
  .showSec-enter-active {
    animation: showSec-in .5s;
  }
  .showSec-leave-active {
    animation: showSec-in .5s reverse;
  }
  @keyframes showSec-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }
</style>



// WEBPACK FOOTER //
// PoPupTextBox.vue?7dc90e5f